const defaultCategory = "UX_ShipmentMgmt";

export default {
  applicationName: "Shipment Management",
  GAeventType: "UXEvent",
  GAEvents: [
    {
      name: "200",
      category: "Tracking",
      action: "Search-shipmentoverview",
      label: "Tracking",
      event: "GAEvent"
    },
    {
      name: "400",
      category: defaultCategory,
      action: "Search-shipmentoverview",
      label: "Bad Result",
      event: "GAEvent"
    },
    {
      name: "401",
      category: defaultCategory,
      action: "Search-shipmentoverview",
      label: "Not authenticated / JWT expired",
      event: "GAEvent"
    },
    {
      name: "403",
      category: defaultCategory,
      action: "Search-shipmentoverview",
      label: "No permission to log in",
      event: "GAEvent"
    },
    {
      name: "404",
      category: "Tracking UX",
      action: "No results found",
      label: "from ShipmentMngt"
    },
    {
      name: "500",
      category: defaultCategory,
      action: "Search-shipmentoverview",
      label: "Internal Server Error",
      event: "GAEvent"
    },
    {
      name: "otherError",
      category: defaultCategory,
      action: "Search-shipmentoverview",
      label: "Unknown error",
      event: "GAEvent"
    },
    {
      name: "etaChangeShown",
      category: defaultCategory,
      action: "ETA Change",
      label: "Shown"
    },
    {
      name: "etaChangeMoreOpened",
      category: defaultCategory,
      action: "ETA Change",
      label: "Viewed"
    },
    {
      name: "etaChangeMoreClosed",
      category: defaultCategory,
      action: "ETA Change",
      label: "Closed"
    },
    {
      name: "containerTrackingLinkClicked",
      category: defaultCategory,
      action: "Ct Tracking",
      label: "click"
    },
    {
      name: "exportTpClicked",
      category: defaultCategory,
      action: "Export",
      label: "click"
    },
    {
      name: "importTpClicked",
      category: defaultCategory,
      action: "Import",
      label: "click"
    },
    {
      name: "oceanTransitTpClicked",
      category: defaultCategory,
      action: "Ocean",
      label: "click"
    },
    {
      name: "vesselDetailsClicked",
      category: defaultCategory,
      action: "Vessel details",
      label: "click"
    },
    { name: "viewDNDClicked", category: defaultCategory, action: "View DD from Import", label: "View DD details" },
    { name: "viewDNDPageParty", category: defaultCategory, action: "View DD page", label: "View DD details - party" },
    {
      name: "viewDNDPageNonParty",
      category: defaultCategory,
      action: "View DD page",
      label: "View DD details - nonParty"
    },
    {
      name: "backToFirstPage",
      category: defaultCategory,
      action: "Back to first page",
      label: "click"
    },
    {
      name: "previousPage",
      category: defaultCategory,
      action: "Previous page",
      label: "click"
    },
    {
      name: "nextPage",
      category: defaultCategory,
      action: "Next page",
      label: "click"
    },
    {
      name: "downloadingFile",
      category: defaultCategory,
      action: "Download document",
      label: "pageNumber"
    },
    {
      name: "paginationUsage",
      category: defaultCategory,
      action: "action",
      label: "label"
    }
  ]
};
